import axios from 'axios';
import { FeedStrategy } from 'views/profiles-strategies/features/feed-strategies/types/feed-strategy.type';

//TODO a lot of feed strategy endpoints are shared in planning and prognosis. make shared CRUD folder and import them into subfeature's CRUD folder?

// GET
// /ewosapi/v2/planandprognosis/feedstrategy/{feedStrategyId}
// Fetches full information about feed strategy from SeaCloud. It also gets from CDC all the related products.
export const getFeedStrategy = async (feedStrategyId: string): Promise<FeedStrategy> => {
  // return FeedStrategyData;
  const res = await axios.get<FeedStrategy>(`/ewosapi/v2/planandprognosis/feedstrategy/${feedStrategyId}`);
  return res.data;
};
